import type { AgreementStatus } from '@catalyst-psa/shared';

import type { Badge } from '../../components/ui/Badge.js';

type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

export const AGREEMENT_STATUS_LABELS: Record<AgreementStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  ended: 'Ended',
};

export const AGREEMENT_STATUS_TONES: Record<AgreementStatus, BadgeTone> = {
  draft: 'gray',
  active: 'green',
  ended: 'amber',
};
